import { type DurationTimeInSeconds, Severity } from '@cobliteam/common-types';

import { TrackingSpeedEventSeverity } from '@cobliteam/api-lib';

import { DateUtils } from '@cobliteam/base-components';

export const trackingSeverityToSeverity = {
  [TrackingSpeedEventSeverity.MEDIUM]: Severity.MEDIUM,
  [TrackingSpeedEventSeverity.HIGH]: Severity.SEVERE,
  [TrackingSpeedEventSeverity.HIGHER]: Severity.VERY_SEVERE,
};

export const durationToHHmmText = (duration: DurationTimeInSeconds) =>
  DateUtils.format(duration, 'HH:mm');
